export default __webpack_public_path__ + "static/media/undraw_select_player_64ca.8f61b148.svg";